import { Component } from '@verndale/core';
import { mediaQuery } from '../helpers/media-queries';
import { LoadSequence } from '../helpers/animations';

class CountryMenu extends Component {
  mq: MediaQueryList;
  isOpen: boolean;

  constructor(el: HTMLElement) {
    super(el);
    this.mq = mediaQuery('desktop');
    this.isOpen = false;
    this.setCurrentCountry();
  }

  setupDefaults() {
    this.dom = {
      $countryMenuButton: this.el.querySelector<HTMLElement>('.country-menu__btn'),
      $countryMenu: this.el.querySelector<HTMLElement>('.country-menu__menu'),
      $cleanButton: this.el.querySelector<HTMLElement>('.country-menu__clean-button'),
      $input: this.el.querySelector<HTMLElement>('.FormTextbox__Input'),
      $list: this.el.querySelector<HTMLElement>('.country-menu__list-items'),
      $listItems: this.el.querySelectorAll<HTMLElement>('.country-menu__list-item'),
      $form: this.el.querySelector<HTMLElement>('.form'),
      $select: this.el.querySelector<HTMLElement>('select'),
      $title: this.el.querySelector<HTMLElement>('.country-menu__heading'),
      $description: this.el.querySelector<HTMLElement>('.country-menu__description'),
      $submitButton: this.el.querySelector<HTMLElement>('.form .button'),
      $noResultsContainer: this.el.querySelector<HTMLElement>('.country-menu__no-results-message'),
      $label: this.el.querySelector<HTMLElement>('.Form__Element__Caption'),
      $whiteArrow: this.el.querySelector<HTMLElement>('.country-menu__chevron-icon--white'),
      $colorArrow: this.el.querySelector<HTMLElement>('.country-menu__chevron-icon--color')
    };
  }

  loadAnimation() {
    LoadSequence(this.el, [
      { element: this.dom.$title as HTMLElement, addScale: false, offset: 0 },
      { element: this.dom.$form as HTMLElement, addScale: false, offset: 0.2 },
      { element: this.dom.$description as HTMLElement, addScale: false, offset: 0.3 }
    ]);
  }

  addListeners() {
    (this.dom.$countryMenuButton as HTMLElement)?.addEventListener(
      'click',
      this.toggleCountryMenu.bind(this)
    );

    (this.dom.$cleanButton as HTMLElement)?.addEventListener('click', this.clearInput.bind(this));

    (this.dom.$input as HTMLElement)?.addEventListener('input', this.filterCountries.bind(this));

    (this.dom.$listItems as NodeList).forEach(item => {
      item.addEventListener('click', this.selectCountry.bind(this));
      item.addEventListener('keydown', this.selectCountry.bind(this));
    });

    document.addEventListener('click', (event: Event) => {
      if (this.isOpen && !(event.target as HTMLElement).classList.contains('country-menu__btn') && !this.el.contains(event.target as Node)) {

        this.toggleCountryMenu();
        (this.dom.$countryMenu as HTMLElement)?.classList.add('hidden');
        (this.dom.$countryMenuButton as HTMLElement)?.classList.remove('active');
      }
    });
  }

  setCurrentCountry() {
    const country = (this.el.dataset as DOMStringMap).currentCountry;
    if (this.dom.$label && country && this.dom.$input) {
      (this.dom.$label as HTMLLabelElement).classList.add('Form__Element__Caption--floating');
      (this.dom.$input as HTMLInputElement).value = country;
    }
  }

  clearInput() {
    (this.dom.$input as HTMLInputElement).value = '';
    (this.dom.$listItems as NodeList).forEach(item => {
      (item as HTMLElement).classList.add('hidden');
    });
    (this.dom.$list as HTMLElement)?.classList.add('hidden');
    (this.dom.$noResultsContainer as HTMLElement)?.classList.add('hidden');
    (this.dom.$cleanButton as HTMLElement)?.classList.add('hidden');
    (this.dom.$submitButton as HTMLButtonElement).disabled = true;
  }

  selectCountry(event: Event) {
    event.preventDefault();
    const input = this.dom.$input as HTMLInputElement;
    const item = (event.target as HTMLElement).closest('.country-menu__list-item') as HTMLElement;

    input.value = item.textContent?.trim() as string;

    (this.dom.$list as HTMLElement)?.classList.add('hidden');

    if ((event as KeyboardEvent).key === 'Enter') {
      (this.dom.$submitButton as HTMLButtonElement).focus();
    }
  }

  filterCountries(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value.toLowerCase();

    if (value.length > 1) {
      (this.dom.$submitButton as HTMLButtonElement).disabled = false;
      const listItems = this.dom.$listItems as NodeListOf<HTMLElement>;
      (this.dom.$cleanButton as HTMLElement)?.classList.remove('hidden');

      if (value) {
        (this.dom.$list as HTMLElement)?.classList.remove('hidden');
      } else {
        (this.dom.$list as HTMLElement)?.classList.add('hidden');
      }

      const showingItems = [...listItems].filter(item => {
        const countryName = item.textContent?.toLowerCase();
        if (countryName?.includes(value)) {
          const boldedCountry = (item.textContent as string).replace(new RegExp(`(${value})`, 'gi'), `<strong>$1</strong>`);
          item.innerHTML = `<a href='#'>${boldedCountry}</a>`;
          item.classList.remove('hidden');
          return true;
        } else {
          item.classList.add('hidden');
          return false;
        }
      });

      if (showingItems.length === 0) {
        (this.dom.$noResultsContainer as HTMLElement)?.classList.remove('hidden');
        (this.dom.$list as HTMLElement)?.classList.add('hidden');
      } else {
        (this.dom.$noResultsContainer as HTMLElement)?.classList.add('hidden');
      }
    } else {
      (this.dom.$list as HTMLElement)?.classList.add('hidden');
      (this.dom.$cleanButton as HTMLElement)?.classList.add('hidden');
      (this.dom.$noResultsContainer as HTMLElement)?.classList.add('hidden');
      (this.dom.$submitButton as HTMLButtonElement).disabled = true;
    }
  }

  toggleCountryMenu() {
    if (!this.isOpen) {
      this.loadAnimation();

      (this.dom.$countryMenu as HTMLElement)?.classList.remove('hidden');
      (this.dom.$countryMenuButton as HTMLElement)?.classList.add('active');
      (this.dom.$whiteArrow as HTMLElement).style.transform = 'rotate(270deg)';
      (this.dom.$colorArrow as HTMLElement).style.transform = 'rotate(270deg)';
      this.isOpen = true;
    } else {
      (this.dom.$countryMenu as HTMLElement)?.classList.add('hidden');
      (this.dom.$countryMenuButton as HTMLElement)?.classList.remove('active');
      (this.dom.$whiteArrow as HTMLElement).removeAttribute('style');
      (this.dom.$colorArrow as HTMLElement).removeAttribute('style');
      this.isOpen = false;
    }
  }
}

export default CountryMenu;
